__turbopack_context__.v({
  "currency": "price-module-scss-module__i9JOFW__currency",
  "green": "price-module-scss-module__i9JOFW__green",
  "lessThan": "price-module-scss-module__i9JOFW__lessThan",
  "minus": "price-module-scss-module__i9JOFW__minus",
  "num1": "price-module-scss-module__i9JOFW__num1",
  "num16": "price-module-scss-module__i9JOFW__num16",
  "num16Bold": "price-module-scss-module__i9JOFW__num16Bold",
  "num1Bold": "price-module-scss-module__i9JOFW__num1Bold",
  "num2": "price-module-scss-module__i9JOFW__num2",
  "num20": "price-module-scss-module__i9JOFW__num20",
  "num20Bold": "price-module-scss-module__i9JOFW__num20Bold",
  "num3": "price-module-scss-module__i9JOFW__num3",
  "num4": "price-module-scss-module__i9JOFW__num4",
  "numTitle": "price-module-scss-module__i9JOFW__numTitle",
  "plus": "price-module-scss-module__i9JOFW__plus",
  "price": "price-module-scss-module__i9JOFW__price",
  "red": "price-module-scss-module__i9JOFW__red",
  "wrapper": "price-module-scss-module__i9JOFW__wrapper",
});
